import PropTypes from "prop-types";

export const LadShape = {
  code: PropTypes.string.isRequired,
  default_name: PropTypes.string,
  lad_name: PropTypes.string,
  id: PropTypes.number.isRequired,
  lob_name: PropTypes.string,
  description: PropTypes.string.isRequired
};

const LABEL_UNCLASSIFIED = "Unclassified";

export const getLadName = lad => lad.lad_name || lad.default_name;

export const getLadLobLabel = lad => {
  if (lad == undefined) {
    return LABEL_UNCLASSIFIED;
  }
  return `${getLadName(lad)} (${lad.lob_name})`;
};

/* Hardcoded since the client wanted a defined order */
export const LOBS = ["Assembly", "Vehicles", "Aftermarket Parts"];



// WEBPACK FOOTER //
// ./src/components/lads.js